import { StyleSheet } from 'aphrodite';
import { THEME } from '../../../components-v2/Theme/theme';
import { brandPrimaryText } from '../../../styles/colors';

export const styleSheet = StyleSheet.create({
	buttonContainer: {
		display: 'flex',
		justifyContent: 'space-around',
		width: 200,
		gap: 16,
	},
	container: {
		padding: '20px 0',
	},
	cardsGrid: {
		display: 'grid',
		gridTemplateColumns: 'repeat(auto-fill, minmax(300px, 1fr))',
		gap: 20,
		padding: '20px 0',
	},
	icon: {
		width: '100%',
		height: '100%',
		objectFit: 'contain' as const,
		color: brandPrimaryText,
		fontSize: 24,
		lineHeight: 1.01,
	},
	statusText: {
		fontSize: THEME.typography.fontSizes.xs,
	},
});
